import { gql } from "@apollo/client";
import { client } from './client'; // Your Apollo client





export const SEAT_UPDATED_SUBSCRIPTION = gql`
  subscription SeatUpdated($id: String!) {
    seatUpdated(id: $id) {
      id
      seatName
      seatFor
      status
      seatCode
      clientInfo {
        _id
        name
        phoneNumber
        gender
        img
        email
        unpaidAmt
        totalVisit
        lastVisit
        ewalletAmt
        points
        address
      }
      serviceInfo
    }
  }
`;



// export const SEAT_UPDATED_SUBSCRIPTION = gql`
//   subscription SeatUpdated($id: ID!) {
//     seatUpdated(id: $id) {
//       id
//       seatName
//       seatFor
//       status
//       seatCode
//       clientInfo {
//         _id
//         name
//         phoneNumber
//         gender
//         img
//         email
//         unpaidAmt
//         totalVisit
//         lastVisit
//         ewalletAmt
//         points
//         address
//       }
//       serviceInfo
//     }
//   }
// `;



const formatGraphQLInput = (obj) => {
    const formatValue = (value) => {
        if (typeof value === 'string') {
            return `"${value}"`;
        }
        if (typeof value === 'boolean' || typeof value === 'number') {
            return value;
        }
        if (Array.isArray(value)) {
            return `[${value.map(formatValue).join(', ')}]`;
        }
        if (typeof value === 'object' && value !== null) {
            const entries = Object.entries(value).map(([k, v]) => `${k}: ${formatValue(v)}`);
            return `{${entries.join(', ')}}`;
        }
        return value;
    };

    const entries = Object.entries(obj).map(([key, value]) => {
        return `${key}: ${formatValue(value)}`;
    });

    return `{${entries.join(', ')}}`;
};

export const ElevateService = {
    updateSeat: async (jsonData, id) => {
        try {
            const inputString = formatGraphQLInput(jsonData);

            const mutationString = `
                mutation UpdateSeat($id: String!) {
                    updateSeat(id: $id, input: ${inputString}) {
                        success
                        message
                        data {
                            _id
                            serviceInfo
                        }
                    }
                }
            `;

            console.log('Generated mutation:', mutationString);

            const mutation = gql`${mutationString}`;

            const { data } = await client.mutate({
                mutation: mutation,
                variables: { id },
                errorPolicy: 'all'
            });

            console.log('Mutation result:', data);
            return data;
        } catch (error) {
            console.error('Failed to update seat:', error);

            if (error.graphQLErrors) {
                error.graphQLErrors.forEach(({ message, locations, path }) =>
                    console.error(`GraphQL error: ${message}`, { locations, path })
                );
            }
            if (error.networkError) {
                console.error('Network error:', error.networkError);
            }

            throw error;
        }
    }
};

export const handleUpdateApollo = async (json, setLoading) => {
    let result;

    try {
        setLoading(true);

        var id = json._id;
        delete json._id;

        result = await ElevateService.updateSeat(json, id);
        console.log('Apollo success:', result);

    } catch (error) {
        console.error('Apollo error:', error);
        throw error;

    } finally {
        setLoading(false);
    }

    return result;
};
